<template>
  <div :class="$style.content">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'AuthSeparatorLine',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" module>
.content {
  display: flex;
  align-items: center;
  font-size: var(--font-size-small);
  color: var(--color-neutral-800);

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: var(--color-neutral-500);
  }

  &::before {
    margin-right: var(--space-small-xx);
  }

  &::after {
    margin-left: var(--space-small-xx);
  }
}
</style>
